import { render } from "./ConfirmModal.vue?vue&type=template&id=55a48a4d&scoped=true&ts=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"

import "./ConfirmModal.vue?vue&type=style&index=0&id=55a48a4d&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a48a4d"]])

export default __exports__